export const leadSourceReferral = 'Referral'
export const leadSource = [
  'Google Search',
  'LinkedIn',
  'Email',
  leadSourceReferral,
  'Review Site',
  'Reddit',
  'Podcast',
  'Event',
  'Webinar',
  'ChatGPT',
  'Other LLM',
  'Instagram',
  'Facebook',
  'Databricks',
  'Snowflake',
  'TV',
  'Other',
]
